import { DEBUG } from "../../../config";
import { sleep } from "../../../lib/gramjs/Helpers";
import { globalDexieDb } from "../db/DexiedbLib";
import { ParseAndSaveMessageLocal } from "../db/service/parserService";
import Parser from "../restapi/parser";
import worker from "../setupWorker";
import { IsMessageAutoParsed, IsMessageParsed, MarkMessageAutoParsed, MarkMessageParsed, SendTeleMessage } from "../tdlib/tdlib";
import { LotMessage } from "../types/types";
import { getCurDate, getDateString, getTimeString, secondsToDateString, secondsToTimeString } from "../utils/DateTimeUtils";
import { roundToFirstDecimalPlace } from "../utils/NumberUtilsTs";
import { BuildSMSTraLaiMB } from "../utils/buildSMS";
import { GetTinhId, isCuPhapMb, isCuPhapMn, isLocalMode, Remove2C3C4C } from "../utils/common";
import _ from 'lodash';
type ChuyenStruct = {
    diemChuyen: number;
    kieuChuyen: 'PT' | 'DIEM';//PT, DIEM
}
type SttStruct = {
    stt: number;
    loaiCuocId: string;
    diem: number;
}
type ItemKhoang = {
    tu: number, den: number, diem: number, dvt: string
}
export type GiuLaiNgoaiLe = {
    giuTheoSoCuoc: { [key: string]: number }
    giuTheoKhoang: { [key: string]: ItemKhoang[] }
    dataKhoang: { [key: string]: any }
    loaiSoDiem: Map<string, number>

}
export function initGiuLaiNgoaiLe(): GiuLaiNgoaiLe {
    return {
        giuTheoSoCuoc: {},
        giuTheoKhoang: {},
        dataKhoang: {},
        // kết quả giữ ăn, cuối cùng được lưu vào đây.
        loaiSoDiem: new Map<string, number>()
    }
}
type MapStt = Map<string, SttStruct>
/**Tất cả sort sẽ thực hiện ở client, giảm tải cho mysql
 * 
*/
export function sortDataCanChuyen(dataCanChuyen: any) {
    if (!dataCanChuyen.dataCanChuyenStruct)
        return;
    if (dataCanChuyen.dataCanChuyenStruct.length == 0)
        return;
    //tính số thừa và số sẽ giữ lại
    for (let row of dataCanChuyen.dataCanChuyenStruct) {
        const diemThucNhan = row.diemThucNhan
        const diemDaChuyen = row.diemDaChuyen
        const thua = getThua(row, dataCanChuyen.diemByStt, dataCanChuyen)
        const diemGiuLai = diemThucNhan - diemDaChuyen - thua
        row.diemGiuLai = diemGiuLai
        row.thua = thua
    }
    if (!dataCanChuyen.dataCanChuyenStruct)
        return;
    dataCanChuyen.dataCanChuyenStruct.sort((a: any, b: any) => {
        if (a.daiId1 !== b.daiId1) {
            if (a.daiId1 > b.daiId1)
                return 1;
            else if (a.daiId1 < b.daiId1)
                return -1;
            else
                return 0;

        }


        if (a.daiId2 !== b.daiId2) {
            if (a.daiId2 > b.daiId2)
                return 1;
            else if (a.daiId2 < b.daiId2)
                return -1;
            else
                return 0;

        }


        if (a.loaiCuocId !== b.loaiCuocId) {
            if (a.loaiCuocId > b.loaiCuocId)
                return 1;
            else if (a.loaiCuocId < b.loaiCuocId)
                return -1;
            else
                return 0;

        }


        if (a.thua !== b.thua) {
            if (b.thua > a.thua)
                return 1;
            else if (b.thua < a.thua)
                return -1;
            else
                return 0;
        }
        if (a.diemGiuLai !== b.diemGiuLai) {
            if (b.diemGiuLai > a.diemGiuLai)
                return 1;
            else if (b.diemGiuLai < a.diemGiuLai)
                return -1;
            else
                return 0;
        }


        if (a.soCuoc > b.soCuoc)
            return 1;
        else if (a.soCuoc < b.soCuoc)
            return -1;
        else
            return 0;
    })
    /*tính toán luôn số thứ tự theo từng loại và tổng điểm nhận, chuyển, thừa theo từng loại*/
    let mapTotal: Map<string, number> = new Map<string, number>();
    let stt = 1;
    let preDaiLoaiCuoc = '';
    const length = dataCanChuyen.dataCanChuyenStruct.length;
    for (let index = 0; index < length; index++) {

        const item = dataCanChuyen.dataCanChuyenStruct[index];
        const key = `${item.daiId1}.${item.daiId2}:${item.loaiCuocId}`;
        if (index == length - 1)
            item['lastItem'] = true;
        else
            item['lastItem'] = false;
        if (key != preDaiLoaiCuoc) {

            if (stt == length) {
                item['lastItem'] = true;
            } else if (preDaiLoaiCuoc != '') {
                dataCanChuyen.dataCanChuyenStruct[index - 1]['lastItem'] = true;
            }
            stt = 1;
        }
        else {
            stt++;
        }

        //
        item['stt'] = stt;
        // add to map

        preDaiLoaiCuoc = key;
        let mapItem = mapTotal.get(key);
        if (mapItem == undefined || mapItem == null) {
            mapItem = item.thua;
        } else {
            mapItem += item.thua;
        }
        mapTotal.set(key, mapItem!);
    }
    dataCanChuyen['mapTotal'] = mapTotal;
    return dataCanChuyen
}
// giữ lại theo từng số, theo từng khoảng
// build luôn mảng dữ liệu và sắp xếp theo nve giảm dần để sử dụng
export function buildGiuLaiNgoaiLe(dataCanChuyen: any): GiuLaiNgoaiLe {
    const giuLaiNgoaiLe: GiuLaiNgoaiLe = initGiuLaiNgoaiLe()
    if (!dataCanChuyen.jsonNgoaiLe) {
        return giuLaiNgoaiLe;
    }
    const objNgoaiLe = JSON.parse(dataCanChuyen.jsonNgoaiLe)
    const compactData: any[] = objNgoaiLe.compactData
    const giuTheoKhoang: string[] = objNgoaiLe.giuTheoKhoang

    compactData.map((row: any) => {
        const dbType = mapParserTypeToDbType(row.loai, row.so)
        const key = `${dbType}:${row.so}`
        giuLaiNgoaiLe.giuTheoSoCuoc[key] = row.diem
    })
    giuTheoKhoang.map((text: string) => {
        const arr = text.split("/")
        if (arr.length > 0) {
            const dbType = mapParserTypeToDbType(arr[0])
            const sttnve = arr[1]
            const diem = Number(arr[2])
            const dvt = arr[3]
            const arrThamSo = sttnve.split("$")
            if (arrThamSo.length > 0) {
                const tu = Number(arrThamSo[1])
                const den = Number(arrThamSo[3])
                let arr1 = giuLaiNgoaiLe.giuTheoKhoang[dbType]
                if (arr1 == undefined) {
                    arr1 = [] as ItemKhoang[]
                    giuLaiNgoaiLe.giuTheoKhoang[dbType] = arr1
                }
                const key = `${dbType}`
                giuLaiNgoaiLe.giuTheoKhoang[dbType].push({ tu: tu, den: den, diem: diem, dvt: dvt })
            }
        }
    })
    dataCanChuyen.giuLaiNgoaiLe = giuLaiNgoaiLe
    const keys = Object.keys(giuLaiNgoaiLe.giuTheoKhoang)
    dataCanChuyen.dataCanChuyenStruct && dataCanChuyen.dataCanChuyenStruct.map((row: any) => {
        if (keys.includes(row.loaiCuocId)) {
            let arr: any = giuLaiNgoaiLe.dataKhoang[row.loaiCuocId] || undefined
            if (arr == undefined) {
                arr = []
                giuLaiNgoaiLe.dataKhoang[row.loaiCuocId] = arr
            }
            //thêm bản ghi mới vào
            arr.push(row)
        }
    })
    const keysLoaiCuoc = Object.keys(giuLaiNgoaiLe.dataKhoang)
    keysLoaiCuoc.map((key: string) => {
        giuLaiNgoaiLe.dataKhoang[key].sort((a: any, b: any) => b.diemThucNhan - a.diemThucNhan)
    })
    //tính kết quả theo khoảng để sau chỉ cần tra lấy điểm
    keysLoaiCuoc.map((key: string) => {
        const sortedData = giuLaiNgoaiLe.dataKhoang[key]
        sortedData.map((row: any, index: number) => {
            const diemGiu = getDiemGiuTheoThamSoKhoang(row, dataCanChuyen, index)
            const key = `${row.loaiCuocId}:${row.soCuoc}`
            if (!isNaN(diemGiu))
                giuLaiNgoaiLe.loaiSoDiem.set(key, diemGiu)
        })
    })
    // số cụ thể ưu tiên cao nhất nên add đè vào sau cùng
    const keySoCuoc = Object.keys(giuLaiNgoaiLe.giuTheoSoCuoc)
    keySoCuoc.map((key: string) => {
        const diemGiu = giuLaiNgoaiLe.giuTheoSoCuoc[key] || 0
        giuLaiNgoaiLe.loaiSoDiem.set(key, diemGiu)
    })
    console.log(giuLaiNgoaiLe)
    return giuLaiNgoaiLe
}
function getDiemGiuTheoThamSoKhoang(row: any, dataCanChuyen: any, index: number): number {
    /*dòng sau đè dòng trước, do vậy dùng for ,cái cuối cùng sẽ có hiệu lực
    ví dụ: nvetu1 nveden 22 x100n 
    nvetu 21 nveden 45 x 200n thì dòng thứ 2 đè dòng thứ nhất (trùng 21,22)
    */
    const arrThamSo = dataCanChuyen.giuLaiNgoaiLe.giuTheoKhoang[row.loaiCuocId]
    let diem = NaN;
    arrThamSo.map((item: ItemKhoang) => {
        const tu = item.tu - 1;
        const den = item.den - 1;
        if (index >= tu && index <= den) {
            if (item.dvt != "%")
                diem = item.diem;
            else {
                let pt = item.diem;
                if (pt > 100) pt = 100
                diem = row.diemThucNhan / 100 * pt;
            }
        }

    })
    return diem;
}
export function mapParserTypeToDbType(parserType: string, so?: string): string {

    let result = parserType
    switch (parserType) {
        case "L":
            result = "Lo";
            break;
        case "LA":
            result = "LoA";
            break;
        case "D":
            result = "De";
            break;
        case "DA":
            result = "DeA";
            break;
        case "1":
            result = "Giai1";
            break;
        // case "2":
        //     result = "Giai2";
        //     break;
        // case "3":
        //     result = "Giai3";
        //     break;
        case "X":
            if (so) {
                const len = so.length;
                switch (len) {
                    case 5:
                        result = "Xi2";
                        break;
                    case 8:
                        result = "Xi3";
                        break;
                    case 11:
                        result = "Xi4";
                        break;
                }
            }
            break;
    }
    return result;
}
export function buildDiemByStt(dataCanChuyen: any): MapStt {
    const result = new Map<string, SttStruct>()
    const dataByLoaiCuoc = new Map<string, any[]>()
    Object.keys(dataCanChuyen.foundStt).map((key: string) => {
        const item = dataCanChuyen.foundStt[key]
        item['diem'] = 0
        result.set(key, item)
    })
    // bắt đầu filter để tính điểm của bộ số có stt=n
    if (result.size > 0) {
        dataCanChuyen.dataCanChuyenStruct.map((row: any) => {
            if (result.has(row.loaiCuocId)) {
                let tmp: any[] = []
                if (dataByLoaiCuoc.has(row.loaiCuocId))
                    tmp = dataByLoaiCuoc.get(row.loaiCuocId)!

                tmp.push(row)

                dataByLoaiCuoc.set(row.loaiCuocId, tmp)
            }
        })
    }
    if (dataByLoaiCuoc.size > 0) {
        dataByLoaiCuoc.forEach((value: any[], key: string) => {
            value.sort((a: any, b: any) => b.diemThucNhan - a.diemThucNhan) // sắp giảm dần, muốn tăng dần thì đổi chỗ
            //a.diemThucNhan-b.diemThucNhan
            dataByLoaiCuoc.set(key, value)
        })
    }
    // có dữ liệu đã được sắp xếp của data theo điểm thực nhận giảm dần, bắt đầu gán số điểm vào kết quả
    for (let [key, value] of result.entries()) {
        //console.log(`Key: ${key}, Value: ${value}`);
        const index = value.stt - 1;
        if (index >= 0 && dataByLoaiCuoc.has(key)) {
            const arr: any[] | undefined = dataByLoaiCuoc.get(key)
            if (arr && arr?.length >= index) {
                value.diem = arr[index].diemThucNhan;
                result.set(key, value)
            }
        }
    }
    dataCanChuyen.diemByStt = result;
    return result
}
export function buildSms(dataCanChuyen: any, textChuyen: string): [string[], any] {
    const smsLength = 2000;
    let result: string[] = []
    const map: Map<string, string> = new Map()
    const chuyenStruct: ChuyenStruct = buildChuyenStruct(textChuyen)

    dataCanChuyen.dataCanChuyenStruct && dataCanChuyen.dataCanChuyenStruct.map((row: any) => {
        //const thua = getThua(row, dataCanChuyen.diemByStt, dataCanChuyen);
        let diemChuyen = chuyenStruct.diemChuyen;
        if (chuyenStruct.kieuChuyen == "DIEM") {
            if (diemChuyen > row.thua)
                diemChuyen = row.thua;
        } else {
            diemChuyen = row.thua / 100 * chuyenStruct.diemChuyen
        }
        row["diemSeChuyen"] = diemChuyen.toFixed(1).replace(".0", "").replace(",0", "")
        //
        if (diemChuyen > 0) {
            let key = `${row.daiId1}.${row.daiId2};${row.loaiCuocId};${row.diemSeChuyen}`

            if (isXien3mien(row.loaiCuocId)) {
                if (isCuPhapMn())
                    key = `${row.daiId1}.${row.daiId2};${row.loaiCuocId};${row.diemSeChuyen};${row.soCuoc}`

            }
            addMaCuocToHashMap(map, key, row);
        }
    })
    //có hashMap, bắt đầu build sms
    if (isCuPhapMn())
        result = buildSMSMN(map, smsLength)
    else
        result = buildSMSMB(map, smsLength)
    return [result, map]
}
export function addMaCuocToHashMap(map: Map<string, string>, key: string, row: any) {
    let found = map.get(key);
    if (found == null || found == undefined)
        map.set(key, row.soCuoc);
    else {
        if (isXien3mien(row.loaiCuocId))
            found = found + "/" + row.soCuoc; // xiên miền bắc, dùng dấu / để phân tách

        else
            found = found + "," + row.soCuoc;
        map.set(key, found);
    }
}

export function buildSMSMN(map: Map<string, string>, smsLength: number) {
    let result = []
    let curSms = ""
    let preDai = ""
    let count = 0
    for (const [key, soCuoc] of map) {
        const arr = key.split(";") // dai,loai,diem
        const dai = getDaiText(arr[0])

        const loai = getLoaiText(arr[1])
        const diem = roundToFirstDecimalPlace(Number(arr[2]))
        let tmpSms;
        let daiAdd = dai;
        if (preDai == dai) {
            daiAdd = "";
        }
        tmpSms = `${daiAdd}${soCuoc}${loai}${diem}n.`
        //console.log(`${key} ${soCuoc}`)
        if (curSms == "")
            curSms = tmpSms
        else {
            if ((curSms + tmpSms).length > smsLength) {
                result.push(curSms)
                curSms = tmpSms
                if (!curSms.startsWith(dai))
                    curSms = dai + curSms
            } else {
                curSms += tmpSms;
            }
        }
        //lặp hết, chuẩn bị sang vòng sau
        preDai = dai;
        count++
        //
        if (count == map.size) {
            if (curSms != "")
                result.push(curSms)
        }
    }
    return result
}
function getDvtByLoai(loai: string) {
    switch (loai.toLocaleLowerCase()) {
        case "lo": case "loa":
            return "d";
        default:
            return "n";
    }
}
/**key = dai1.dai2;loai;diem value=day so cuoc*/
export function buildSMSMB(map: Map<string, string>, smsLength: number) {
    let result = []
    let curSms = ""
    let preLoai = ""
    let count = 0
    // Sắp xếp Map theo key giảm dần
    const sortedMap = new Map(
        [...map.entries()].sort((a, b) => {
            const [daiA, loaiA, diemA] = a[0].split(";");
            const [daiB, loaiB, diemB] = b[0].split(";");
            if (daiA < daiB) return 1; // Đảo thứ tự để giảm dần
            if (loaiA < loaiB) return 1;
            if (Number(diemA) < Number(diemB)) return 1;
            return 0;
        })
    );

    for (const [key, soCuoc] of sortedMap) {
        const arr = key.split(";") // dai,loai,diem


        const loai = getLoaiText(arr[1])
        const dvt = getDvtByLoai(loai);//
        const diemFloat = arr[2]
        let diem = loai != 'lo' ? Math.floor(Number(diemFloat)) : Number(diemFloat)
        diem = roundToFirstDecimalPlace(diem)
        let tmpSms;
        let loaiAdd = loai + ":";
        if (preLoai == loai && preLoai != "") {
            loaiAdd = ""
        } else {
            // xuống dòng
            curSms += curSms != "" ? "\n\n" : "";
        }
        if (diem == 0) {
            count++;
            preLoai = '';// điểm ==0, bị loại, nên ko có loại cược cho mượn nữa
            if (count == map.size && curSms != '') {
                result.push(curSms);
                curSms = '';
            }
            continue;
        }
        tmpSms = `${loaiAdd}${soCuoc}x${diem}${dvt}.`
        //console.log(`${key} ${soCuoc}`)
        if (curSms == "")
            curSms = tmpSms
        else {
            if ((curSms + tmpSms).length > smsLength) {
                result.push(curSms)
                tmpSms = `${loai}:${soCuoc}x${diem}${dvt}.`
                curSms = tmpSms

            } else {
                curSms += tmpSms;
            }
        }
        //lặp hết, chuẩn bị sang vòng sau
        preLoai = loai
        count++
        //push sms cuối cùng vào kết quả
        if (count == map.size) {
            if (curSms != "")
                result.push(curSms)
        }
    }

    return result
}
export function getDaiText(dai: string): string {
    const arr = dai.split(".")
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] == "BD")
            arr[i] = "BDG"
        else if (arr[i] == "BL")
            arr[i] = "BLI"
        else if (arr[i] == "DL")
            arr[i] = "DLAT"
    }

    return arr.join(".");
}
export function getLoaiText(loaiCuocId: string): string {
    let text = Remove2C3C4C(loaiCuocId)

    if (text.startsWith("6") || text.startsWith("7") || text.startsWith("8"))
        text = "b" + text;
    text = text.toLowerCase()
    if (text == '3c1') {
        text = '3cang giai 1';
    }
    if (text == '3c1a') {
        text = '3cang giai 1 a';
    }
    if (text == '3ca') {
        text = '3cang a';
    }
    return text
}
/*Tính số thừa có thể chuyển đi*/
export function getThua(row: any, diemByStt: any, dataCanChuyen: any): number {
    /* let thua = 0

    if (row.kieuGiu == "DIEM") {
        thua = row.diemThucNhan - row.diemDaChuyen
        if (thua - row.diemGiu >= 0) {
            thua = thua - row.diemGiu
        } else {
            thua = 0 // điểm giữ lớn hơn số đang có
        }
        // } else
        //     thua = 0
    } else if (row.kieuGiu == "PT") {

        thua = row.diemThucNhan - (row.diemGiu) / 100 * row.diemThucNhan - row.diemDaChuyen
        // if (thua < 0)
        //     thua = 0
    } else if (row.kieuGiu == "STT") {
        let thamSo: SttStruct = diemByStt.get(row.loaiCuocId)
        let conLai = row.diemThucNhan - row.diemDaChuyen
        if (conLai > thamSo.diem) {
            if (conLai <= row.min) {
                thua = 0
            } else {
                thua = conLai - thamSo.diem
                conLai = row.diemThucNhan - row.diemDaChuyen - thua
                if (conLai < row.min) {
                    thua = row.diemThucNhan - row.diemDaChuyen - row.min
                }
            }
        }
        else
            thua = 0;
        //console.log(diemByStt)
    }

    //tiếp đến xem có giữ theo khoảng, hoặc giữ theo số cược hay không
    if (dataCanChuyen.giuLaiNgoaiLe) {
        const key = row.loaiCuocId + ":" + row.soCuoc
        const diemGiu = dataCanChuyen.giuLaiNgoaiLe.loaiSoDiem.get(key)
        if (!isNaN(diemGiu)) {

            thua = row.diemThucNhan - row.diemDaChuyen - diemGiu

        }

    }
    //
    let conLai = row.diemThucNhan - row.diemDaChuyen - thua
    //
    switch (row.kieuGiu) {
        case "PT":
            if (row.min > 0) {
                if (conLai < row.min)
                    thua = row.diemThucNhan - row.diemDaChuyen - row.min
            }
            if (row.max > 0) {
                if (conLai > row.max)
                    thua = thua + conLai - row.max
            }
            break
    }
    if (thua < 0) thua = 0; */
    /*Dùng kết quả tính toán ở sv, ko tính trên client cho dễ quản lý 1 code base dùng lại nhiều lần*/
    return row.diemThua;//Math.round(thua * 10) / 10;
}
export function buildChuyenStruct(textChuyen: string): ChuyenStruct {
    let result: ChuyenStruct = { diemChuyen: 0, kieuChuyen: "DIEM" }
    const regex = /([1-9][0-9]*)\s*(%|n)?/
    const matches = textChuyen.match(regex)
    if (matches?.length == 3) {
        if (matches[1] != undefined)
            result.diemChuyen = Number(matches[1])
        if (matches[2] != undefined)
            result.kieuChuyen = matches[2] == "%" ? "PT" : "DIEM"
        else
            result.kieuChuyen = "DIEM"

    }
    return result;
}
export async function parseMessageAuto(msg: any, sendMessage: Function) {
    const [autoParseIn, autoParseOut] = await IsAutoParseInOut()
    if (!autoParseIn && !autoParseOut) {
        return;
    }
    if (msg.isOutgoing && !autoParseOut) {
        return
    }
    if (!msg.isOutgoing && !autoParseIn) {
        return
    }
    ///
    const dateString = secondsToDateString(msg.date)
    if (dateString != getCurDate()) {
        return;
    }
    const timeString = secondsToTimeString(msg.date)
    if (!msg.content.text) {
        return
    }
    if (!msg.content.text.text) {
        return
    }
    let text = msg.content.text.text
    // if (msg.isOutgoing) {
    //     text = text.replace(/tra lai/i, "")
    // }
    const body: LotMessage = {
        body: text,
        bodyOrigin: text,
        date: dateString,
        time: timeString,
        type: msg.isOutgoing ? 2 : 1,
        contactId: -1,
        curMien: isCuPhapMb() ? 'BAC' : 'NAM',
        getCompactData: 1,
        getRawData: 0,
        lockArea: 0,
        tlMessageId: Number(msg.id),
        tlChatId: (msg.chatId),
        tlUserId: Number(msg.chatId),
        tlChatTitle: "",
        loaiBoTinTrung: 1
    }
    let result;
    if ((await IsMessageAutoParsed(body))) {
        if (DEBUG)
            console.log("Auto parse đã phân tích, ko pt lại:" + body.tlMessageId, body.date)

        return;
    }
    if (isLocalMode()) {

        result = await ParseAndSaveMessageLocal(body)

    }
    else {
        result = await Parser.parseMessage(body)
    }
    if (result.errorCode == 0 && result.data.parseStatus == "parseOK") {
        let msgTextNotify = result.data.responseText


        if (DEBUG)
            console.log("Auto parse Thành công:" + body.body, body.date)
        MarkMessageParsed(body, true)
        if (result.data.tongSoTinDen > 0) {
            await sleep(500)
            SendTeleMessage(`#wapp: Nhận ${result.data.tongSoTinDen} tin`, body.tlChatId + "", sendMessage)

        }

        if (result.data.traLai && result.data.traLai.length > 0) {

            const sms = result.data.traLaiSoVuot
            console.log("tra lai:", sms)
            await sleep(500)
            SendTeleMessage(sms, `${body.tlChatId}`, sendMessage)

        }

        if (result.data.tinTraLaiQuaGio && result.data.tinTraLaiQuaGio.length > 0) {
            const text = "tra lai qua gio:" + result.data.tinTraLaiQuaGio
            await sleep(500)
            SendTeleMessage(`${text}`, `${body.tlChatId}`, sendMessage)

        }
    } else {
        MarkMessageAutoParsed(body, true)
        if (DEBUG)
            console.log("Auto parse  Lỗi phân tích:" + body.body)

    }
    return;
}
export async function parseMessageManual(msg: { text: string, contactId: number, type: number, curMien: string, date: string }) {

    ///
    const d = new Date()
    const dateString = getDateString(d)
    const timeString = getTimeString(d)
    const { text, contactId, type, curMien, date } = msg
    // if (msg.isOutgoing) {
    //     text = text.replace(/tra lai/i, "")
    // }
    const body: LotMessage = {
        body: text,
        bodyOrigin: text,
        date: date,
        time: timeString,
        type: type,
        contactId: contactId,
        curMien: curMien, //BAC TRUNG NAM
        getCompactData: 1,
        getRawData: 0,
        lockArea: 0,
        tlMessageId: 0,
        tlChatId: 0,
        tlUserId: 0,
        tlChatTitle: "",
        loaiBoTinTrung: 1
    }
    let result;

    if (isLocalMode()) {

        result = await ParseAndSaveMessageLocal(body)

    }
    else {
        result = await Parser.parseMessage(body)
    }
    if (result.errorCode == 0 && result.data.parseStatus == "parseOK") {
        let msgTextNotify = result.data.responseText


        if (DEBUG)
            console.log("Manual parse Thành công:" + body.body, body.date)
        MarkMessageParsed(body, true)
        worker.postMessage({ type: 'showsnackbar', data: 'Phân tích tin gửi đi thành công, đã trừ số liệu' })

    } else {
        MarkMessageAutoParsed(body, true)
        if (DEBUG)
            console.log("Manual parse  Lỗi phân tích:" + body.body)
        let msgTextNotify = result.data.responseText
        worker.postMessage({ type: 'showsnackbar', data: 'Lỗi phân tích tin giử đi.' + msgTextNotify })

    }
    return;
}
async function IsAutoParseInOut(): Promise<[boolean, boolean]> {
    const tinhId = GetTinhId()
    const found = await globalDexieDb.userConfig.where("tinhId").equals(tinhId).first()
    if (found) {
        return [found.autoParseIn == 1, found.autoParseOut == 1]
    }
    else {
        return [false, false]
    }
}
export function isXien3mien(loaiCuocId: string): boolean {
    return "DaT,DaX,Xi2,Xi3,Xi4".includes(loaiCuocId);
}